export const DEALER_BRANDING = 'dealerBranding';
